<ml-maximum-resident-users-ui (maximumResidentUsers)="maximumResidentUsers($event)"></ml-maximum-resident-users-ui>